import { PropsWithChildren } from "react";

export const TRow = ({ children, ...rest }: React.HTMLProps<HTMLTableRowElement> & PropsWithChildren) => <tr {...rest}>{children}</tr>;
export const TData = ({ children, ...rest }: React.HTMLProps<HTMLTableCellElement> & PropsWithChildren) => <td {...rest}>{children}</td>;
export const THead = ({ children, ...rest }: React.HTMLProps<HTMLTableCellElement> & PropsWithChildren) => <th {...rest}>{children}</th>;